import { z } from "zod"
import { Errors } from "../errors"

export const GrantCompanyAccessSchema = z.object({
  employeeId: z.string(),
  companyIds: z.array(z.string()).min(1, "At least one company must be selected"),
})

export type GrantCompanyAccessInput = z.infer<typeof GrantCompanyAccessSchema>

export const RevokeCompanyAccessSchema = z.object({
  employeeId: z.string(),
  companyIds: z.array(z.string()).min(1, "At least one company must be selected"),
})

export type RevokeCompanyAccessInput = z.infer<typeof RevokeCompanyAccessSchema>

export const UpdateEmployeeCompanyAccessSchema = z
  .object({
    isManager: z.boolean(),
    companyIds: z.array(z.string()),
  })
  .refine((data) => data.isManager || data.companyIds.length > 0, {
    path: ["companyIds"],
    message: Errors.EMPLOYEE_PERMISSIONS_REQUIRED,
  })

export type UpdateEmployeeCompanyAccessInput = z.infer<typeof UpdateEmployeeCompanyAccessSchema>

export const GetEmployeePermissionsSchema = z.object({
  employeeId: z.string(),
})

export type GetEmployeePermissionsInput = z.infer<typeof GetEmployeePermissionsSchema>
